import { Component, OnInit } from '@angular/core';
import { PageErrorState } from './models/pageErrorState.model';

@Component({
  selector: 'app-error',
  standalone: true,
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss',
})
export class ErrorComponent {
  themeIsLight: boolean;

  authText: string = 'User Authorization Error';
  errorMessage: string = 'There is an error with your user role. You must create a service desk request to obtain correct roles to access ClaytonNext or QBuilt. If the issue still persists please contact your administrator or manager.';
  errorLink: string = 'https://www.claytontechnow.com/sp?id=clayton_ec_dashboard';
  errorLinkText: string = 'Link to Service Desk';

  constructor() {}

}
